import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "66",
  height: "69",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F5F5F5",
      d: "M0 10.898c0-5.522 4.477-10 10-10h45.65c5.523 0 10 4.478 10 10V58.71c0 5.523-4.477 10-10 10H10c-5.523 0-10-4.477-10-10z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      "fill-opacity": ".3",
      d: "M30.666 28.124H16.863c-.477 0-.863-.354-.863-.786s.386-.787.863-.787h13.803c.474 0 .863.354.863.787 0 .432-.389.786-.863.786m-1.725 1.573c.474 0 .862.354.862.787 0 .432-.388.786-.862.786H18.588c-.477 0-.863-.354-.863-.786s.386-.787.863-.787zm-1.726 3.146c.475 0 .863.354.863.787s-.388.787-.863.787H16.863c-.477 0-.863-.354-.863-.787s.386-.787.863-.787zm2.588 10.226c0 2.173-1.93 3.932-4.313 3.932s-4.314-1.76-4.314-3.932c0-2.173 1.93-3.933 4.314-3.933 2.383 0 4.313 1.76 4.313 3.933m15.529 0c0 2.173-1.93 3.932-4.313 3.932s-4.314-1.76-4.314-3.932c0-2.173 1.93-3.933 4.314-3.933 2.383 0 4.313 1.76 4.313 3.933"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#000",
      d: "M19.453 24.191c0-1.303 1.159-2.36 2.588-2.36h13.803c1.43 0 2.589 1.057 2.589 2.36v2.36h2.733c.917 0 1.747.33 2.443.92l4.168 3.8c.647.59 1.008 1.39 1.008 2.226v5.639c.955 0 1.726.703 1.726 1.573s-.772 1.573-1.726 1.573H47c-.42-2.67-2.938-4.72-5.98-4.72-3.04 0-5.558 2.05-5.979 4.72h-3.57c-.42-2.67-2.938-4.72-5.979-4.72-2.593 0-4.807 1.495-5.662 3.545a1.97 1.97 0 0 1-.377-1.184v-5.506h7.765c.474 0 .862-.354.862-.787s-.388-.787-.862-.787h-7.765V31.27h9.49c.474 0 .863-.354.863-.786s-.389-.787-.863-.787h-9.49v-1.573h11.215c.475 0 .863-.354.863-.786s-.388-.787-.863-.787H19.453zm25.881 10.226v-.92l-4.168-3.8h-2.733v4.72z"
    }, null, -1)
  ])))
}
export default { render: render }